import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AiSearchService } from '../../../../shared/services';
import { AiSearchDto } from '../../../../shared/models';
import {
  ACCURACY_LEVELS,
  AccuracyLevelConfig,
  DEFAULT_ACCURACY_LEVEL,
} from './search-accuracy.config';

@Injectable({
  providedIn: 'root',
})
export class SearchAccuracyService {
  readonly levels: AccuracyLevelConfig[] = ACCURACY_LEVELS;
  readonly defaultLevel: number = DEFAULT_ACCURACY_LEVEL;

  constructor(private aiSearchService: AiSearchService) {}

  getLevelConfig(level: number): AccuracyLevelConfig | undefined {
    return this.levels.find((config) => config.level === level);
  }

  applyAccuracyLevel(aiSearchId: string, level: number): Observable<AiSearchDto | null> {
    return this.aiSearchService.changeAccuracyLevel(aiSearchId, level);
  }
}
